module.exports = __webpack_public_path__ + "static/media/compras.1a59d6ec.svg";